import { render, staticRenderFns } from "./IntegrationUfi.vue?vue&type=template&id=3b7c9907&scoped=true"
import script from "./IntegrationUfi.vue?vue&type=script&lang=js"
export * from "./IntegrationUfi.vue?vue&type=script&lang=js"
import style0 from "./IntegrationUfi.vue?vue&type=style&index=0&id=3b7c9907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7c9907",
  null
  
)

export default component.exports